<template>

  <div class="orderColumn" id="orderColumn" ref="orderColumn">
      
  </div>
  
</template>

<script>
export default {
    
  name: "orderColumn",
  mounted() {
    this.orderColumn();
  },
  methods: {
    orderColumn() {
      let myEchart = this.$echarts.init(document.getElementById("orderColumn"));

      let option = {
    
    tooltip: {
        trigger: 'axis',
        axisPointer: {
            type: 'shadow'
        }
    },
    grid: {
        top: '15%',
        right: '1%',
        left: '10%',
        bottom: '14%',
        containLabel: true,
    },
    xAxis: [{
        type: 'category',
        data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
        axisLine: {
            lineStyle: {
                color: '#696868'
            }
        },
        axisLabel: {
            margin: 10,
            color: '#696868',
            textStyle: {
                fontSize: 12
            },
        },
        axisTick: {
            show: false
        }
    }],
    yAxis: [{
        name:'工单量 (个)',      
        nameGap:10,
        nameTextStyle:{
            color:'#efefef',
            fontSize:12,
            padding:[0,0,0,70]

        },
        axisLabel: {
            show:false,
            formatter: '{value}',
            color: '#e2e9ff',
        },
        axisTick: {
            show: false
        },
        axisLine: {
            show: false,
            
            lineStyle: {
                color: 'rgba(0,186,255,.6)'
            }
        },
        splitLine: {
            lineStyle: {
                color: '#242220',
                type:'dashed'
            }
        }
    }],
    series: [{
        type: 'bar',
        data: [80, 75, 60, 53, 85, 26, 72],
        barWidth: '28px',
        itemStyle: {
            normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: 'rgba(211,98,24,0.9)' // 0% 处的颜色
                }, {
                    offset: 1,
                    color: 'rgba(211,98,24,0.2)' // 100% 处的颜色
                }], false),
                
                shadowBlur: 4,
            }
        },
        
    }]
};

      myEchart.setOption(option);
      window.addEventListener("resize", () => {
        myEchart.resize();
      });
    },
  },
};
</script>

<style scoped>
.orderColumn {
  width: 100%;
  height: 100%;
}
</style>
